<template>
  <div v-if="userData" data-ui="titlebar" class=" text-white flex dark:rounded electron:min-h-[40px]"
       :class="[userData?.client == 'development' ? 'bg-trader-dark-green electron:bg-transparent' : 'bg-trader-darkest-gray electron:bg-trader-title-bar']">
    <div class="w-[80px]" v-if="inElectron"></div>

    <router-link :to="seToolUrl"
                 class="flex justify-center items-center py-1 px-2 hover:bg-trader-darker-gray hover:text-black cursor-pointer"
                 :class="{ 'bg-trader-blue dark:rounded': $route.path.startsWith('/project') || $route.path.startsWith('/list') || $route.path.startsWith('/sort') }"
                 data-ui="nav-se-tool">
      <span>SE-Tool</span>
    </router-link>

    <!--
    <router-link to="/grid">Raster</router-link>
    <router-link to="/product">{{ $t('app.menu.product') }}</router-link>
    -->

    <!-- TODO: Implement the following drop-down menu -->
    <!--
    <drop-down>
      <template v-slot:title>
        <div class="py-1 px-2 hover:bg-trader-darker-gray hover:text-black cursor-pointer"
             :class="{ 'bg-trader-blue': $route.path.startsWith('/export') || $route.path.startsWith('/import') }" data-ui="nav-import-export">
          Import & Export
        </div>
      </template>
      <template v-slot:menu>
        <router-link to="/export/excel" class="block px-4 py-2 hover:bg-trader-blue hover:text-white" data-ui="excel-export">Excel-Export
        </router-link>
        <router-link to="/export/csv" class="block px-4 py-2 hover:bg-trader-blue hover:text-white" data-ui="csv-export">CSV-Export
        </router-link>
        <router-link to="/export/txt" class="block px-4 py-2 hover:bg-trader-blue hover:text-white" data-ui="txt-export">TXT-Export
        </router-link>
        <router-link v-if="userData.isAdmin" to="/export/indesign"
                     class="block px-4 py-2 hover:bg-trader-blue hover:text-white" data-ui="indesign-export">InDesign Export
        </router-link>
      </template>
    </drop-down>
    -->


    <router-link v-if="(userData.isAdmin || userData.isMarketing) && projectId != 0 && magazineId != 0 "
                 :to="`/administration/2/Page/${projectId}/${magazineId}/${pagePosition}/${marketId}`"
                 data-ui="nav-administration"
                 class="flex justify-center items-center py-1 px-2 hover:bg-trader-darker-gray hover:text-black cursor-pointer"
                 :class="{ 'bg-trader-blue dark:rounded': $route.path.startsWith(`/administration`) }">
      <span>Verwaltung</span>
    </router-link>
    <router-link v-else-if="userData.isAdmin || userData.isMarketing" to="/administration/0"
                 data-ui="nav-administration"
                 class="flex justify-center items-center py-1 px-2 hover:bg-trader-darker-gray hover:text-black cursor-pointer"
                 :class="{ 'bg-trader-blue dark:rounded': $route.path.startsWith('/administration') }">
      <span>Verwaltung</span>
    </router-link>
    <button @click="openExelImportDialog"
            class="flex justify-center items-center py-1 px-2 hover:bg-trader-darker-gray hover:text-black cursor-pointer">
      <span>Import & Export</span>
    </button>

    <router-link to="/asset" v-if="inElectron"
                 class="flex justify-center items-center py-1 px-2 hover:bg-trader-darker-gray hover:text-black cursor-pointer"
                 :class="{ 'bg-trader-blue dark:rounded': $route.path.startsWith('/asset') }">
      <span>{{ $t('app.menu.asset') }}</span>
    </router-link>

    <router-link to="/article" v-if="inElectron"
                 class="flex justify-center items-center py-1 px-2 hover:bg-trader-darker-gray hover:text-black cursor-pointer"
                 :class="{ 'bg-trader-blue dark:rounded': $route.path.startsWith('/article') }">
      <span>Artikel</span>
    </router-link>

    <router-link to="/apps" v-if="inElectron"
                 class="flex justify-center items-center py-1 px-2 hover:bg-trader-darker-gray hover:text-black cursor-pointer"
                 :class="{ 'bg-trader-blue dark:rounded': $route.path.startsWith('/apps') }">
      <span>Apps & Updates</span>
    </router-link>

    <div class="flex-grow flex justify-center items-center electron-title-bar">

      <h1 v-if="inElectron" class="font-bold text-sm">Trader Client</h1>

    </div>


    <!--
    <router-link v-if="userData.isAdmin"
                 :to="`/help`"
                 data-ui="nav-administration"
                 class="flex justify-center items-center py-1 px-2 hover:bg-trader-darker-gray hover:text-black cursor-pointer"
                 :class="{ 'bg-trader-blue dark:rounded': $route.path.startsWith(`/help`) }">
      <span>Hilfe</span>
    </router-link>
    -->

    <div class="flex justify-center items-center  py-1 pr-2 pl-2">
      <span>
      <i class="fa-solid fa-server" style="font-size:14px;"></i>
      {{ userData.client }}
        </span>
    </div>

    <div class="flex justify-center items-center py-1 px-2 hover:bg-trader-darker-gray hover:text-black cursor-pointer"
         @click="toggleDarkMode">
      <div v-if="this.theme === 'dark'">
        <span>
          <i class="fa-solid fa-palette" style="font-size:14px;"></i>
          Helles Design
        </span>
      </div>

      <div v-else>
        <span>
          <i class="fa-solid fa-palette" style="font-size:14px;"></i>
          Dunkles Design
        </span>
      </div>
    </div>


    <drop-down data-ui="user-drop-down" :bind-right="true" class="">
      <template v-slot:title>

        <div class="flex justify-center items-center h-full hover:bg-trader-darker-gray hover:text-black cursor-pointer"
             :class="{ 'bg-trader-blue': $route.path.startsWith('/user' ) }" data-ui="user-dropdown-menu">
          <div class="h-full pl-2 pr-1 self-stretch flex items-center">
            <i v-if="userData.isAdmin" class="fa-solid fa-user-gear" style="font-size:14px;"></i>
            <i v-if="!userData.isAdmin && userData.isMarketing" style="font-size:14px;" class="fa-solid fa-user"></i>
            <i v-if="!userData.isAdmin && !userData.isMarketing" style="font-size:14px;"
               class="fa-solid fa-user-tag"></i>
          </div>
          <div class="py-1 pr-2" :data-ui="'Active-user-' + userData.userName">
            {{ userData.userName }}
          </div>
        </div>

      </template>

      <template v-slot:menu>
        <div class="">
          <div data-ui="user-switch">
            <div v-for="user in users" :key="user.username" class="group" >
              <div
                  class="flex px-4 py-3 hover:underline cursor-pointer transition-colors duration-200 border-b border-gray-50 last:border-b-0"
                  :class="{ 'bg-trader-blue text-trader-text': userData.userName.toLowerCase().replace(/_/g, ' ') === user.username.toLowerCase().replace(/_/g, ' ')
                && userData.client.toLowerCase() === user.client.toLowerCase() }">
                <div class="flex-1" @click="changeUser(user)" :data-ui="user.username">
                  <div class="font-semibold text-sm">
                    {{ user.username }}
                  </div>
                  <div class="text-xs opacity-75 mt-0.5">
                    {{ user.client }}
                  </div>
                </div>
                <div class="flex items-center gap-2 ml-2">
                  <button @click.stop="deleteUser(user)" :data-ui="'delete-user-' + user.username"
                          class="opacity-0 group-hover:opacity-100 transition-opacity duration-200 p-1 hover:bg-red-100 rounded"
                          :title="`${user.username} löschen`">
                    <svg class="w-4 h-4 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                    </svg>
                  </button>

                </div>
              </div>
            </div>
          </div>
          <div class="border-t border-gray-200 mt-1 pt-1">
            <button @click="loginNewUser" data-ui="login-new-user"
                    class="w-full text-left px-4 py-2 hover:bg-trader-blue hover:text-white transition-colors duration-200">
              Anderer Benutzer
            </button>
          </div>

          <div class="border-t border-gray-200 pt-1">
            <router-link to="/user"
                         class="block px-4 py-2 hover:bg-trader-blue hover:text-white transition-colors duration-200"
                         data-ui="user-settings">
              Benutzer verwalten
            </router-link>
            <router-link to="/logout"
                         class="block px-4 py-2 hover:bg-trader-blue hover:text-white transition-colors duration-200"
                         data-ui="user-logout">{{
                $t('app.menu.logout')
              }}
            </router-link>
          </div>
        </div>
      </template>
    </drop-down>

    <a class="lex justify-center items-center bg-trader-dark-red py-1 px-2 hover:bg-trader-darker-gray hover:text-black cursor-pointer"
       data-ui="Impersonate-beenden"
       href="/api/v3/exit/impersonate" v-if="userData?.originalUserId > 0">
      <span>Impersonate beenden</span>
    </a>


  </div>
</template>


<script>
import DropDown from "@/components/MainMenu/DropDown.vue";
import {mapActions, mapState} from "vuex";
import storage from "@/application/storage";
import {eventBus} from "@/application/EventBus";
import ChoseExcelImport from "@/components/Dialogs/ChoseExcelImport.vue";
import axios from "axios";
import LoginWithUser from "@/components/Dialogs/LoginWithUser.vue";

// eslint-disable-next-line no-undef
//window.i18n.global.locale = response.data.getUserInfo.language;

export default {
  name: "MainMenu",
  components: {
    DropDown
  },
  data() {
    return {
      userName: "",
      userId: 0,
      projectId: 0,
      magazineId: 0,
      pagePosition: 0,
      marketId: 0,
      accordionIndex: 0,
      articleNumber: 0,
      isDarkMode: false,
      users: [],
    }
  },
  props: {
    toggleDarkMode: {
      type: Function,
      default: () => {
      }
    },
    inElectron: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('user', ['userData']),
    ...mapState('settings', ['theme']),
    isInAdministrationOnPage() {
      const regexMatch = /\/administration\/\d+\/page\/(\d+)\/(\d+)\/(\d+)\/(\d+)/;
      return regexMatch.test(this.$route.path);
    },
    seToolUrl() {
      let url = '/project';
      if (this.projectId !== 0) {
        url += `/${this.projectId}`;
        if (this.magazineId !== 0) {
          url += `/${this.magazineId}`;
          url += `/${this.pagePosition}`;
          url += `/${this.marketId}`;

          if (this.accordionIndex !== 'null') {
            url += `/${this.accordionIndex}`;
          }
        }
      }
      return url;
    }
  },
  methods: {
    ...mapActions('user', ['fetchUserData']),

    openExelImportDialog() {
      eventBus.openModal(ChoseExcelImport, {
        title: "Import & Export",
        magazineId: this.magazineId,
        projectId: this.projectId,
      }, {
        halfSize: true
      });
    },
    changeUser(user) {

      axios.post('/api/v3/changeUser', {
        client: user.client,
        username: user.username,
        password: user.password
      }).then((response) => {
        // reload the page to apply the new user context
        window.location.reload();
      }).catch((error) => {

      });
    },
    loginNewUser() {
      eventBus.openModal(LoginWithUser, {
        title: "Anmelden",
        onAccept: () => {
          //  window.location.reload();
        }
      }, {
        halfSize: true
      });
    },
    deleteUser(user) {
      this.users = this.users.filter(u => !(u.username === user.username && u.client === user.client));
      localStorage.setItem('users', JSON.stringify(this.users));
    },

    /*
    // Funktion zum Wechseln des Dark Modes
    const toggleDarkMode = () => {
      isDarkMode.value = !isDarkMode.value;
      updateDarkMode();
    };

    // Funktion zum Aktualisieren des Dark Mode Status
    const updateDarkMode = () => {
      if (isDarkMode.value) {
        document.documentElement.classList.add('dark');
        document.body.classList.add('dark-trader-background'); // Hier die Hintergrundfarbe im Dark Mode setzen
        localStorage.setItem('theme', 'dark');
      } else {
        document.documentElement.classList.remove('dark');
        document.body.classList.remove('dark-trader-background'); // Hintergrundfarbe im Light Mode zurücksetzen
        localStorage.setItem('theme', 'light');
      }
    };
    */

    /*
    getURLParts() {
      const regexMatch = /\/administration\/\d+\/page\/(\d+)\/(\d+)\/(\d+)\/(\d+)/;
      const matches = this.$route.path.match(regexMatch);
      if (matches) {
        return {
          projectId: matches[1],
          magazineId: matches[2],
          pagePosition: matches[3],
          marketId: matches[4]
        };
      }
      return {
        projectId: 0,
        magazineId: 0,
        pagePosition: 0,
        marketId: 0
      };
    }
    */
  },
  mounted() {
    this.fetchUserData();
    //this.applyTheme();
    this.users = JSON.parse(localStorage.getItem('users') || '[]');


  },
  async created() {
    if (this.$isParamDefined('projectId')) {
      this.projectId = parseInt(this.$route.params.projectId);
      await storage.set('projectId', this.projectId);
    } else {
      this.projectId = await storage.get('projectId');
    }

    if (this.$isParamDefined('magazineId')) {
      this.magazineId = parseInt(this.$route.params.magazineId);
      await storage.set('magazineId', this.magazineId);
    } else {
      this.magazineId = await storage.get('magazineId');
    }

    if (this.$isParamDefined('pagePosition')) {
      this.pagePosition = parseInt(this.$route.params.pagePosition);
      await storage.set('pagePosition', this.pagePosition);
    } else {
      this.pagePosition = await storage.get('pagePosition');
    }

    if (this.$isParamDefined('marketId')) {
      this.marketId = parseInt(this.$route.params.marketId);
      await storage.set('marketId', this.marketId);
    } else {
      this.marketId = await storage.get('marketId');
    }

    //accordionIndex
    if (this.$isParamDefined('accordionIndex')) {
      this.accordionIndex = parseInt(this.$route.params.accordionIndex);
      await storage.set('accordionIndex', this.accordionIndex);
    } else {
      this.accordionIndex = await storage.get('accordionIndex');
    }
  },
  watch: {
    '$route.params': {
      handler: async function (params) {

        if (params?.projectId && params?.projectId !== '') {
          this.projectId = params.projectId;
          await storage.set('projectId', this.projectId);
        } else {
          this.projectId = await storage.get('projectId');
        }

        if (params?.magazineId && params?.magazineId !== '') {
          this.magazineId = params.magazineId;
          await storage.set('magazineId', this.magazineId);
        } else {
          this.magazineId = await storage.get('magazineId');
        }

        if (params?.pagePosition && params?.pagePosition !== '') {
          this.pagePosition = params.pagePosition;
          await storage.set('pagePosition', this.pagePosition);
        } else {
          this.pagePosition = await storage.get('pagePosition');
        }

        if (params?.marketId && params?.marketId !== '') {
          this.marketId = params.marketId;
          await storage.set('marketId', this.marketId);
        } else {
          this.marketId = await storage.get('marketId');
        }

        //accordionIndex
        if (params?.accordionIndex && params?.accordionIndex !== '') {
          this.accordionIndex = params.accordionIndex;
          await storage.set('accordionIndex', this.accordionIndex);
        } else {
          this.accordionIndex = await storage.get('accordionIndex');
        }

      },

    }
  }

};
</script>
